import { Component } from "react";

export class EditorPlayerImage extends Component {
  override render() {
    return (
      <div
        className="w-100 h-100 w-full h-full"
        style={{
          objectFit: "cover",
          objectPosition: "center",
          backgroundColor: "black",
        }}
      />
    );
  }
}

export default EditorPlayerImage;
